<template>
	<div id="payWatch">
		<div class="banner">
			<img :src="imgScr">
		</div>
		<div class="musk">
			<div v-if="type == 1" class="passwordBox">
				<van-password-input
					:value="value"
					:info="'说明：'+couponText"
				/>
				<button class="button" @click="password">确定</button>

				<!-- 数字键盘 -->
				<van-number-keyboard
					:show="showKeyboard"
					@input="onInput"
					@delete="onDelete"
				/>
			</div>
			<div class="box" v-else-if="type == 2">
				<div class="title">门票观看</div>
				<div class="ticket">
					<h4>门票价格</h4>
					<h5>￥ 
						<span class="money" v-if="payIndex >= 0">
							<template v-if="(price >= coupons[payIndex].money)/100">
								{{(price-coupons[payIndex].money)/100}}
							</template>
							<template v-else>
								0
							</template>
						</span>
						<span v-else>{{price/100}}</span>
					</h5>
				</div>
				<ul class="coupons" v-if="coupons.length">
					<li v-for="(item,index) in coupons" @click="select(index,item.id)" :class="{cur:payIndex == index}">
						<i></i>
						<span>{{item.money/100}}元门票券</span>
					</li>
					<li @click="select(-1,0)" :class="{cur:payIndex == -1}">
						<i></i>
						<span>不使用</span>
					</li>
				</ul>
				<p class="explain" v-if="couponText">说明：{{couponText}}</p>
				<p class="explain" v-else>说明：请购买门票进行观看</p>
				<button class="button" @click="bugTicket">购买</button>
			</div>

			<div class="box allot shareCard" v-else>
				<img :src="allot.pic">
				<div class="allot_title">{{allot.title}}<span>精选课程</span></div>
				<div class="allot_price"><span class="yuan">￥</span>{{allot.price/100}}</div>
				<div class="allot_ul">
					邀请收益：¥ {{allot.allot_money/100}} / 人 <span></span>收益比例：{{allot.rate*100}}％
				</div>
				<div class="allot_yao" @click="onshowArrow">邀请好友</div>
				<div class="allot_pay" @click="allotPay">立即购买</div>
				<div class="allot_info">
					<h4>邀请说明</h4>
					<p>每当好友购买成功，即可立即获得本次邀请收益，收益将自动存入您的<span>微信钱包</span></p>
				</div>
			</div>
		</div>
		<div class="musk2" v-show="showArrow" @click="oncloseArrow">
			<div class="arrow">
				<img :src="imgPath+'payWatch/arrow.png'">
				<p>点击这里分享邀请哦～</p>
			</div>
		</div>
	</div>
</template>

<script>
import Vue from 'vue';
import tool,{app_Id} from '../../kits/Tools.js';
import { Toast } from 'vant';
import vxxData from '../../kits/data.js';
import md5 from 'blueimp-md5';
import { PasswordInput, NumberKeyboard } from 'vant';
Vue.use(PasswordInput).use(NumberKeyboard);

	export default {
		data() {
			return {
				initData:'',
				imgScr: "",
				fans_id:"",
				passwd:'',
				ds_id:'',
				type:1,
				couponText:'',
				value:'',
				price:"0",
				payData:'',
				passshow:true,
				showKeyboard: true,
				coupons:[],
				payIndex:-1,
				coupon_id:0,
				showArrow:false,
				imgPath:'',
				allot:{},
				sid:0,
				user:''
			}
		},
		mounted() {
			var that = this;
			this.initData = vxxData.getInitData();
			this.user = this.$route.params.user;
			
			console.log("设置了权限观看");
			console.log(this.initData);
			
			if(!this.initData) {
				if(this.user){
					this.$router.push({
						name: 'home',
						params: {
							user: that.user
						}
					});
					return;
				}else{
					this.$router.push({
						name: 'home'
					});
					return;
				}
			}
			
			this.type = this.$route.params.type;
			this.ds_id = tool.getQueryDsId();
			this.sid = sessionStorage.getItem('sid');
			this.imgScr = tool.baseUrl1()+"/wap/index/dsImg/?ds_id=" + this.ds_id;
			this.allot = this.initData.ds_pwd.params;
			this.allot.pic = this.initData.direct_seeding.pic_url;
			this.allot.title = this.initData.direct_seeding.name;
			if(this.type == 1){
				this.passwd = this.initData.ds_pwd.params.http_url;
			}else if(this.type == 2){
				this.price = this.initData.ds_pwd.params.price;
				if(this.initData.ds_pwd.params.ticket_switch == 1){
					tool.getCoupon(this.getCoupon);
				}
			}else{
               //获取用户信息
			   tool.login(app_Id,this.initData.direct_seeding.uid,this.personDataInit);
			}
			this.imgPath = tool.imgPath();
			this.couponText = this.initData.ds_pwd.params.text;
		},
		methods: {
			 personDataInit(fans){
			  //重缓存中获取数据
			   this.fans_id = fans.fans_id;
			},
			getCoupon(coupons){
				this.coupons = coupons;
				console.log(this.coupons.length);
			},
			password() {
				//加密成md5
				var passwd = md5(this.value+'auth');
				var that = this;
				if(!this.value){
					Toast("请输入密码");
				}
				if(passwd == this.passwd) {
					Toast("验证通过");
					var today = (new Date()).toLocaleDateString();
					localStorage.setItem("passwordDay",today);
					//tool.setCookie("password",passwd,1)
					setTimeout(function(){
						that.$router.push({
							name: 'home'
						});
					},2000)
				} else {
					Toast('密码错误');
					this.value = "";
				}
			},
			showpass(){
				this.passshow = !this.passshow;
			},
			bugTicket(){
				tool.bugTicket(this.coupon_id,this.payLoad);
			},
			onInput(key) {
				this.value = (this.value + key).slice(0, 6);
			},
			onDelete() {
				this.value = this.value.slice(0, this.value.length - 1);
			},
			select(index,id){
				this.payIndex = index;
				this.coupon_id = id;
			},
			payLoad(){
				var that = this;
				sessionStorage.setItem('initData',null);
				setTimeout(function(){
					that.$router.replace('/home');
					window.location.reload();
				},2000)
			},
			onshowArrow(){
				this.showArrow = true;
			},
			oncloseArrow(){
				this.showArrow = false;
			},
			allotPay(){
				var that = this;
				var option = "ds_id="+this.ds_id+"&fans_id="+this.fans_id;
				if(this.sid && this.sid != 'undefined'){
					option += '&is_allot=1&share_fans_id='+this.sid;
				}
				this.axios.post(tool.baseUrl3()+"/ticket/order",option).then(function(data) {
					tool.weixinPay(data.data.data,function(){
						Toast('付费成功');
						setTimeout(function(){
							that.$router.replace('/home');
							window.location.reload();
						},2000)
					})
				}).catch(function(data) {
					console.log('错误' + data)
				});
			}
		}
	}
</script>

<style scoped>
#payWatch{
	height: 100%;
}
.banner {
	height: 100%;
	width: 100%;
	text-align: center;
}

.banner img {
	height: 100%;
	width: 100%;
	display: block;
}
.coupons{
	padding:0 0 0 100px;
}

.title {
	background-color: #099aff;
	text-align: center;
	padding: 10px 0;
	color: #ffffff;
	font-size: 18px;
}

.password {
	width: 60%;
	height: 40px;
	line-height: 40px;
	border-radius: 20px;
	border: 1px solid #ccc;
	padding: 0 20px;
	margin: 0 auto;
	display: block;
	position: relative;
	overflow: hidden;
}

.password input {
	width: 100%;
	height: 38px;
	border: none
}

.seeword {
	position: absolute;
	height: 42px;
	width: 40px;
	top: 0;
	right: 0;
	text-align: center;
	border-radius: 20px;
}

.seeword img {
	vertical-align: middle;
}

.explain {
	text-align: center;
	font-size: 13px;
	color: #a8a8a8;
	margin-top: 10px;
	line-height: 20px;
}

h3 {
	text-align: center;
	color: #383838;
	margin-top: 20px;
	font-size: 16px;
}

.button {
	width: 80%;
	display: block;
	margin-left: 10%;
	border: 0px;
	padding: 8px 0;
	border-radius: 5px;
	margin-top: 14px;
	margin-bottom: 24px;
	font-size: 17.5px;
	color: white;
	background-image: linear-gradient(0deg,#0190f3 0%, #2ba8ff 100%),linear-gradient(#099aff, #099aff);
	background-blend-mode: normal, normal;
	box-shadow: 2px 4px 21px 0px rgba(0, 96, 255, 0.42);
	border-radius: 20.5px;
}

.ticket {
	width: 30%;
	margin: 20px auto;
	background: #ff9525;
	text-align: center;
	box-shadow: 2px 2px 6px #ccc;
	border-radius: 3px;
	color: #fff;
	padding: 20px 10px;
	position: relative;
}

.ticket:after {
	position: absolute;
	content: "";
	width: 20px;
	height: 20px;
	background: #fff;
	top: -12px;
	left: 50%;
	margin-left: -10px;
	border-radius: 50%;
}

.ticket h4 {
	color: #f6e667;
	letter-spacing: 1px;
	border-bottom: 1px solid #f6e667;
	padding-bottom: 6px;
}

.ticket h5 {
	margin-top: 10px;
	font-size: 16px;
}

.ticket span {
	font-size: 30px;
	font-weight: bold;
}

.passwordBox {
	padding: 100px 0;
	background: #eee;
	height: 100%;
	width: 100%;
}
.allot_yao{
	height: 44px;
	line-height: 44px;
	width: 100%;
	text-align: center;border: 1px solid #c49c5f;
	background: #fff;
	font-size: 18px;
	color: #c49c5f;
	margin-top: 20px;
	box-sizing: border-box;
}
.allot_pay{
	width: 100%;
	height: 44px;
	line-height: 44px;
	background: #c49c5f;
	color: #fff;
	text-align: center;
	margin-top: 15px;
	font-size: 18px;
}
.allot_info{
	margin: 15px 15px 0 15px ;
	text-align: center;
}
.allot_info h4{
	height: 36px;
	font-size: 16px;
	line-height: 36px;
	color: #c49c5f;
	border-bottom: 1px dashed #c49c5f;
}
.allot_info p{
	line-height: 20px;
	margin-top: 10px;
	color: #333333;
	margin-bottom: 10px;
}
.allot_info p span{
	color: #c49c5f;
}
.arrow{
	position: absolute;
	top: 10px;
	right: 40px;
	color: #fff;
	width:200px;
	text-align: right;
	font-size: 18px;
}
.arrow img{
	width: 68px;
}
</style>


// WEBPACK FOOTER //
// payWatch.vue?2e06ec0e